import { SingleQuestionDetailsProvider } from '@exam-management/question-creation-task-question-management';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function QuestionCreationTaskQuestionDetailsLayout() {
  const { taskId, questionId } = useParams('/my-task/question-creation/:taskId/single/:questionId');

  return (
    <SingleQuestionDetailsProvider taskId={taskId} questionId={questionId}>
      <Outlet />
    </SingleQuestionDetailsProvider>
  );
}
